<template>
    <v-dialog v-model="dialog" max-width="610" :fullscreen="$vuetify.breakpoint.xs">
        <v-card class="py-8 px-11">
            <ValidationObserver ref="form" v-slot="{ handleSubmit }">
                <v-form @submit.prevent="handleSubmit(save)">
                    <h2 class="text-center">Edit Quiz</h2>

                    <v-card-actions class="mt-8">
                        <v-btn class="transparent green--text mr-4" :class="quiz.type !== 1 ? 'green-border' : ''"  @click="[quiz.type = 1, uncheckCheckboxes()]" :disabled="quiz.type === 1">One</v-btn>
                        <v-btn class="transparent green--text mx-4" :class="quiz.type !== 2 ? 'green-border' : ''" @click="[quiz.type = 2, uncheckCheckboxes()]" :disabled="quiz.type === 2">Multiple</v-btn>
                        <v-btn class="transparent green--text ml-4" :class="quiz.type !== 3 ? 'green-border' : ''" @click="[quiz.type = 3, uncheckCheckboxes()]" :disabled="quiz.type === 3">In Writing</v-btn>
                    </v-card-actions>

                    <ValidationProvider name="Title" rules="required" v-slot="{ errors }">
                        <v-textarea label="Title"
                                    v-model="quiz.title"
                                    class="mt-8"
                        >
                            <template v-slot:prepend-inner>
                                <svg v-svg="'icon-title'" size="15" class="mr-1"></svg>
                            </template>
                        </v-textarea>
                        <small class="font-weight-bold error--text">{{ errors[0] }}</small>
                    </ValidationProvider>

                    <v-card-text class="px-0">
                        <label for="file" class="text-decoration-underline green--text font-weight-bold">Choose Image</label>
                        <ValidationProvider vid="image" name="Image" rules="mimes:jpeg,png,gif,webp|size:1024" v-slot="{ validate, errors }">
                            <input type="file" id="file" accept="image/jpeg,image/png,image/gif,image/webp" ref="image" @change="previewFiles() || validate($event)"><br>
                            <small class="font-weight-bold error--text">{{ errors[0] }}</small>
                        </ValidationProvider>
                        <v-img :src="imagePreview" width="150px" class="mt-3" v-if="imagePreview"></v-img>
                        <v-img :src="`${API_URL}/storage/quizzes/${quiz.image}`" width="200px" class="mt-3" v-else-if="dialog && !loadingRequest && quiz.image"></v-img>
                    </v-card-text>

                    <ValidationProvider name="Score" rules="required|numeric|between:1,10" v-slot="{ errors }">
                        <v-text-field label="Score"
                                      v-model="quiz.score"
                        >
                            <template v-slot:prepend-inner>
                                <svg v-svg="'icon-score'" size="15" class="mr-1"></svg>
                            </template>
                        </v-text-field>
                        <small class="font-weight-bold error--text">{{ errors[0] }}</small>
                    </ValidationProvider>

                    <ValidationProvider name="Time" rules="required|numeric|between:1,20" v-slot="{ errors }">
                        <v-text-field label="Time (minutes)"
                                      v-model="quiz.time"
                        >
                            <template v-slot:prepend-inner>
                                <svg v-svg="'icon-time'" size="15" class="mr-1"></svg>
                            </template>
                        </v-text-field>
                        <small class="font-weight-bold error--text">{{ errors[0] }}</small><br />
                    </ValidationProvider>

                    <template v-if="quiz.type !== 3">
                        <template v-for="(answer, key) in quiz.answers">
                            <v-layout :key="key" align-center class="flex-auto">
                                <v-checkbox v-model="quiz.answers[key].is_correct"
                                            :false-value="0"
                                            :loading="loadingRequest"
                                            :true-value="1"
                                            :value="key"
                                            class="shrink mr-2"
                                            hide-details
                                            @change="checkCorrect(key)"
                                ></v-checkbox>
                                <ValidationProvider v-slot="{ errors }" :name="`Answer ${key + 1}`" class="valid"
                                                    rules="required">
                                    <v-textarea v-model="quiz.answers[key].answer"
                                                :label="`Answer ${key + 1}`"
                                                :loading="loadingRequest"
                                                rows="1"
                                                :class="{'font-weight-black': quiz.answers[key].font === '1'}"
                                    ></v-textarea>
                                    <small class="font-weight-bold error--text">{{ errors[0] }}</small>
                                </ValidationProvider>
                                <v-icon class="ml-2 mt-3 pointer" color="error" @click="quiz.answers.splice(key,1)">fas
                                    fa-times
                                </v-icon>
                            </v-layout>
                            <v-card-text class="px-0">
                                <v-checkbox
                                    label="Bold"
                                    v-model="quiz.answers[key].font"
                                    class="shrink mr-2"
                                    :value="0"
                                    true-value="1"
                                    false-value="0"
                                ></v-checkbox>
                                <label :for="`file${key}`"
                                       class="text-decoration-underline green--text font-weight-bold">Choose
                                    Image</label>
                                <ValidationProvider v-slot="{ validate, errors }" :name="quiz.answers[key].imagePreview"
                                                    rules="mimes:jpeg,png,gif,webp|size:1024"
                                                    vid="image">
                                    <input :id="`file${key}`" :ref="`image${key}`" accept="image/jpeg,image/png,image/gif,image/webp"
                                           class="file" type="file"
                                           @change="previewAnswerFiles(key) || validate($event)"><br>
                                    <small class="font-weight-bold error--text">{{ errors[0] }}</small>
                                </ValidationProvider>
                                <v-img v-if="quiz.answers[key].imagePreview || quiz.answers[key].image" :src="typeof quiz.answers[key].image === 'string' ? `${API_URL}/storage/answers/${quiz.answers[key].image}`  :   quiz.answers[key].imagePreview" class="mt-3"
                                       width="150px"></v-img>
                            </v-card-text>
                        </template>


                        <v-btn color="warning" class="mt-10" @click="((quiz.answers.length && quiz.answers[quiz.answers.length - 1].answer)
                        || !quiz.answers.length) && quiz.answers.push({answer: '', image: '',imagePreview: '',is_correct: false})">Add
                        </v-btn>
                    </template>

                    <v-card-actions class="d-flex justify-center mt-6">
                        <v-btn class="green white--text mr-4" type="submit" :loading="loadingSave">Save</v-btn>
                        <v-btn class="transparent green--text ml-4" @click="dialog = false">Close</v-btn>
                    </v-card-actions>
                </v-form>
            </ValidationObserver>
        </v-card>
    </v-dialog>
</template>

<script>
    export default {
        props : ['quiz_id'],
        data(){
            return {
                dialog: false,
                quiz: {
                    type: 1,
                    answers: [],
                },
                image: '',
                imagePreview: '',
                loadingRequest: false,
                loadingSave: false,
            }
        },

        watch: {
            'dialog': function (newVal) {
                if(newVal) {
                    this.loadingRequest = true;
                    this.imagePreview = '';
                    this.image = '';
                    this.$apiAdmin('quizzes').show(this.quiz_id).then((res) => {
                        this.quiz = res.data.quiz;
                        this.quiz.answers = res.data.quiz.answers.map(el => {
                            return {
                                answer: el.answer.answer,
                                image: el.answer.image,
                                is_correct: el.is_correct,
                                font: el.answer.font,
                                imagePreview: ''
                            }
                        })
                    }).finally(() => {
                        this.loadingRequest = false;
                        console.log(this.quiz.answers)
                    })
                }
            }
        },

        methods: {
            checkCorrect(index) {
                if (this.quiz.type === 1) {
                    this.quiz.answers = this.quiz.answers.map((item, key) => {
                        if (key !== index)
                            item.is_correct = 0;
                        return item;
                    });
                }
            },

            save() {
                if(!this.quiz.answers.length && this.quiz.type !== 3)
                    this.$store.dispatch('alert', {type: 2, message: 'Please add answers.'});
                else if(!this.quiz.answers.find(item => item.is_correct) && this.quiz.type !== 3)
                    this.$store.dispatch('alert', {type: 2, message: 'Please select correct answer.'});
                else {
                    this.loadingSave = true;

                    let params = new FormData();
                    params.append('type', this.quiz.type);
                    for(const [index, ans] of Object.entries(this.quiz.answers)) {
                        params.append(`answers[${index}][image]`, ans.image);
                        params.append(`answers[${index}][answer]`, btoa(unescape(encodeURIComponent(ans.answer))));
                        params.append(`answers[${index}][is_correct]`, ans.is_correct)
                        params.append(`answers[${index}][font]`, ans.font)
                    }
                    params.append('course_id', this.quiz.course_id);
                    params.append('image', this.image);
                    params.append('score', this.quiz.score);
                    params.append('time', this.quiz.time);
                    params.append('title', btoa(unescape(encodeURIComponent(this.quiz.title))));

                    this.$apiAdmin('quizzes').update(params, this.quiz_id)
                        .then(() => {
                            this.dialog = false;
                            this.quiz = {
                                type: 1,
                                answers: [],
                            };
                            this.$refs.form.reset();
                            this.$parent.$emit('getQuizzes');
                            this.$store.dispatch('alert', {type: 1, message: 'Successfully updated.'});
                        }).catch((err) => {
                            this.$refs.form.setErrors(err.response.data);
                        }).finally(() => {
                            this.loadingSave = false;
                        })
                }
            },

            uncheckCheckboxes() {
                let answers = this.quiz.answers.map((item) => {
                    item.is_correct = 0;
                    return item;
                });
                this.quiz.answers = answers;
            },

            previewFiles() {
                this.image = this.$refs.image.files[0];

                let reader = new FileReader();
                reader.addEventListener('load', function () {
                    this.imagePreview = reader.result;
                }.bind(this), false);

                if (this.image) {
                    if (/\.(jpe?g|png|gif|webp)$/i.test(this.image.name)) {
                        reader.readAsDataURL(this.image);
                    }
                }
            },

            previewAnswerFiles(key) {
                this.quiz.answers[key].image = this.$refs[`image${key}`][0].files[0];

                let reader = new FileReader();
                reader.addEventListener('load', function () {
                    this.quiz.answers[key].imagePreview = reader.result;
                }.bind(this), false);

                if (this.quiz.answers[key].image) {
                    if (/\.(jpe?g|png|gif|webp)$/i.test(this.quiz.answers[key].image.name)) {
                        reader.readAsDataURL(this.quiz.answers[key].image);
                    }
                }
            }
        }
    }
</script>

<style scoped lang="scss">
    @import "../../../scss/components/dialog";
    @import "../../../scss/components/Quizzes/dialog";
    .file {
        opacity: 0;
        position: absolute;
        z-index: -1;
    }
</style>